module.exports = "data:image/png;base64,UklGRmwBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSJoAAAABR6GgbSM39rf3HYKPiHikCaVpigTjAIscEsrogC4KN/QdRMEwkmRT975t23/zT/ExhIj+K2zbtsneSXsGqbDzVDmvHhe8jS1a1ggROybwibMIincNBKYBA2+VM85/kwqjqEalhA9AYgCmjqKEuXGaZVObuuKgq03DMC9T3yay/PJR/wNz0+PQ/BP5bT8fO94ttKUBvGTb2tQFVlA4IKwAAAAQAwCdASoQABAAAgA0JYwCdH8CPQH3g5r+Up8DFeTsRHAA/tlfpTQddUqBXTkNce0pWL7LMXJa9Yr1UAAXhSvOq50PgYcK/ugzD1THk0gyOZph0iJPd48b7nm4Lbsif61N2vRHgPVa5Lt16xeF8CLzy+PLSlVovveqUVl/3cg929WH5+f5sG1+58Wc+yJyXx+xflIOmzOjqQZxaAkQfbmNcwIHvttXMKL6IAAA"


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes_icons/icon_Blueprint_Branch_16x.png
// module id = 36
// module chunks = 0